import { Component, OnInit, inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FeedbackResponse } from '@page/main/components/feedback-form/feedback-form.component';
import { MainService } from '@page/main/main.service';
import { NotificationService } from '@services/notification.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-anonymous-feedback',
  templateUrl: './anonymous-feedback.component.html',
  styleUrls: ['./anonymous-feedback.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
  ],
})
export class AnonymousFeedbackComponent implements OnInit {
  private mainService = inject(MainService);
  ntf = inject(NotificationService);
  private dialog = inject(MatDialog);
  data = inject(MAT_DIALOG_DATA);

  form: FormGroup = new FormGroup({
    url: new FormControl({
      value: '',
      disabled: true,
    }),
    subject: new FormControl('', Validators.required),
    text: new FormControl('', Validators.required),
  });

  ngOnInit(): void {
    this.form.patchValue({
      url: location.href,
      subject: this.data,
    });
  }

  onSubmit() {
    if (this.form.valid) {
      const data = this.form.getRawValue();
      // subject в ServiceDeskRequest нет — выделенный фрагмент передаём в начале text
      const payload: FeedbackResponse = {
        text: `${data?.subject}\n\n${data?.text}`,
      };
      this.mainService.sendFeedback(payload).subscribe({
        next: () => {
          this.form.reset();
          this.ntf.showNotification('snackbar-success', 'Ваше сообщение отправлено!');
          this.dialog.closeAll();
        },
        error: (err) => {
          console.error(err);
          this.ntf.showNotification('snackbar-danger', err?.error?.message || 'Ошибка отправки сообщения!');
        },
      });
    }
  }
}
